<template>
  <div class="products-feima-page-content flex flex-col items-center w-full text-left max-ml:overflow-hidden ">
    <section class="relative w-full flex flex-col items-center max-ml:hidden">
      <Pic class="w-full relative z-0 min-h-20rem max-ml:w-100% max-ml:object-cover max-ml:object-center"
        :src="content.banner" alt="" />
      <PageContentCenter class="text-[#616671] absolute top-[8.5rem]">
        <h2 class="text-2.63rem text-[#102136] mb-[32px] font-semibold">
          {{ title }}
        </h2>
        <p class="">{{ description }}</p>
      </PageContentCenter>
    </section>
    <section class="ml:hidden w-full">
      <Pic class="w-full" src="/images/mobile/products/fmwq.png"></Pic>
    </section>

    <section class="relative w-full text-center">
      <PageContentCenter>
        <h2 class="text-[32px] text-[#272E3B] pt-[5rem] mb-35.04px font-bold">
          {{ content.businessIntroduction.title }}
        </h2>
      </PageContentCenter>

      <PageContentCenter class="text-[#616671] text-[16px] relative">
        <div class="relative flex flex-col">
          <div class="relative">
            <h3 class="relative  mb-18.24px feima-business-introduction-title">
              <span class="relative z-2">{{ content.businessIntroduction.subTitle }}</span>
            </h3>

            <ul class="features-group-ul text-left inline-block m-l-1/2 -translate-x-1/2 max-ml:w-100%">
              <li v-for="desc in content.businessIntroduction.descList"
                class="text-[#616671] text-[16px] mb-[18.08px] features-group-li inline-block w-830px max-ml:w-100%">{{
                  desc
                }}
              </li>
            </ul>
          </div>
          <Pic :src="content.businessIntroduction.descImage" class="w-100% self-center"></Pic>
        </div>
      </PageContentCenter>
    </section>

    <section class="w-full ">
      <h2 class="text-[32px] text-[#272E3B] pt-[5rem] font-bold text-center">
        <PageContentCenter>
          {{ content.featuresIntroduction.title }}
        </PageContentCenter>
      </h2>

      <section
        :class="['py-56.96px', group.direction === 'copywriting-to-image' ? '' : 'bg-[linear-gradient(180deg,#FBFDFF_0%,#F9FCFF_100%)]']"
        v-for="group in content.featuresIntroduction.groups">
        <PageContentCenter
          :class="['flex', 'justify-center', 'gap-160px', 'relative', group.direction === 'image-to-copywriting' ? 'ml:flex-row-reverse' : '', 'max-ml:flex-col!', 'max-ml:gap-20px']">
          <div class="w-29rem relative  align-self-center max-ml:w-100%">
            <div :class="['mb-28px']">
              <Pic :src="group.icon" class="w-[88px] h-[80px] mb-28px max-ml:hidden"></Pic>
              <h4 class="text-30.08px">{{ group.title }}</h4>
            </div>
            <ul class="features-group-ul">
              <li v-for="desc in group.descList"
                class="text-[#616671] text-[16px] mb-[32px] features-group-li w-29rem max-ml:w-100% leading-2rem">{{
                  desc
                }}
              </li>
            </ul>
          </div>
          <Pic class="w-42.25rem max-ml:w-100%" :src="group.mainImage" :style="{}"></Pic>
        </PageContentCenter>
      </section>
    </section>

    <section class="w-full relative max-ml:hidden">
      <h2 class="absolute z-1 left-1/2 -translate-x-1/2 text-[32px] text-[#272E3B] font-bold text-center">
        <PageContentCenter>
          {{ content.coreBusiness.title }}
        </PageContentCenter>
      </h2>
      <Pic :src="content.coreBusiness.mainImage" class="relative w-100%  max-ml:w-100%"></Pic>

    </section>

    <section class="relative w-full feima-product-advantage h-930.08px max-ml:h-[auto] ">
      <PageContentCenter class="text-[#272E3B] relative">
        <h2 class="text-2.63rem text-[#fff] pt-[5rem] text-center mb-118.08px font-semibold">
          {{ content.advantage.title }}
        </h2>
        <ul class="flex justify-center gap-39.04px max-ml:flex-col max-ml:items-center max-ml:gap-0px">
          <li v-for="item in content.advantage.list"
            class="feima-product-advantage-item relative max-ml:w-100% relative max-ml:mb-20px">
            <Pic :src="item.icon" class="relative w-21.57rem h-12.43rem"></Pic>
            <h5 class="text-center text-1.25rem text-#080649 font-semibold mt-12px mb-29.28px">{{ item.title }}</h5>
            <p class="text-center text-[#95A6BF] text-0.69rem px-38.08px mb-60.8px h-60px leading-1.5rem">{{
              item.desc }}</p>
          </li>
        </ul>
      </PageContentCenter>
    </section>

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '飞马外勤'
const description = '简单工作快乐生活'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  banner: '/images/pages/products/feima/banner (1).png',
  businessIntroduction: {
    title: '产品业务介绍',
    // 副标题
    subTitle: '和贵科技研发的专业外勤管理软件，深度适配物流、零售、建筑、服务等多个行业场景，致力于帮助企业重塑外勤管理模式 ',
    desc: '',
    mainImage: '/images/pages/products/feima/fm- (3).png',
    descList: [
      '依托智能调度与实时管理，助力企业平均降低外勤人力及管理成本达40%以上，提升外勤工作效率超过25%',
      '典型客户实践显示，市场响应速度提速超30%，让企业在数字化转型中真正实现高效率与低成本的双重突破'
    ],
    descImage: '/images/pages/products/feima/fm- (3).png',
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    groups: [
      {
        title: '客户管理',
        desc: '',
        descList: [
          '系统化、高效率集中管理所有客户信息和业务往来',
          '记录客户详细信息、跟踪每一次沟通历史、科学规划跟进计划，并智能化提醒待办任务',
        ],
        icon: '/images/pages/products/feima/Frame 2147229636@2x(2).png',
        mainImage: '/images/pages/products/feima/Frame 2147229646@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '产品管理',
        desc: '',
        descList: ['构建了一套完整的数字化管理体系，贯穿于产品的整个生命周期。它通过智能化的系统联动与工作流引擎，有效协同市场、销售、服务等多部门作业，显著提升前台业务链条的整体效率与响应速度。该系统在运营中持续生成并聚合关键业务数据，为企业进行精准的运营评估、市场趋势预测以及商业模式优化提供了不可或缺的数据支撑与洞察来源。',],
        icon: '/images/pages/products/feima/Frame 2147229477@2x.png',
        mainImage: '/images/pages/products/feima/Frame 2147229409@2x.png',
        direction: 'image-to-copywriting'
      },
      {
        title: '活动管理',
        desc: '',
        descList: ['活动管理功能提供对各类线下活动的全流程数字化管理', '活动信息的集中记录与共享，帮助团队持续优化策略，确保每一次市场投入都获得清晰可衡量的回报'],
        icon: '/images/pages/products/feima/Frame 2147229478@2x.png',
        mainImage: '/images/pages/products/feima/fm- (1).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '轨迹路径',
        desc: '',
        descList: ['通过将线下行动数据化，企业可以有效优化外勤调度，验证工作执行的到位率与真实性，同时为分析客户分布、提升拜访效率提供数据支撑，是实现精细化外勤管理、降本增效的重要工具',],
        icon: '/images/pages/products/feima/Frame 2147229636@2x(1).png',
        mainImage: '/images/pages/products/feima/Frame 2147229646@2x(2).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '考勤管理',
        desc: '',
        descList: ['员工的出勤数据可被自动、准确地记录与统计，并自动生成可视化的考勤报表', '这不仅简化了繁琐的人工核算工作，实现了公平高效的考勤管理，也为薪资计算和绩效评估提供了精准的数据依据，助力企业人力资源管理的数字化转型'],
        icon: '/images/pages/products/feima/Frame 2147229480@2x.png',
        mainImage: '/images/pages/products/feima/Frame 2147229651@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '报表分析',
        desc: '',
        descList: ['管理者可查看成各类统计报表，一键穿透至明细数据，快速洞察业务趋势、识别核心问题', '它旨在打破数据孤岛，将复杂信息转化为清晰洞见，为战略规划与绩效评估提供精准、可靠的数据支撑，驱动企业实现基于数据的科学决策'],
        icon: '/images/pages/products/feima/dingdan_moren.png',
        mainImage: '/images/pages/products/feima/Frame 2147229834@2x.png',
        direction: 'image-to-copywriting'
      }, {
        title: '检核管理',
        desc: '',
        descList: ['企业的标准化巡检与核查工作提供数字化解决方案，确保了检查过程的规范性与可追溯性，并能自动汇总分析检核数据，生成问题整改单与统计报告，从而帮助企业高效闭环处理隐患，持续提升运营质量与合规性水平',],
        icon: '/images/pages/products/feima/Frame 2147229478@2x(1).png',
        mainImage: '/images/pages/products/feima/Group 2147229631@2x.png',
        direction: 'copywriting-to-image'
      }, {
        title: '进销存管理',
        desc: '',
        descList: ['现对采购、销售、库存流转的一体化数字管控，企业能够精准掌握每一商品的实时库存量，有效避免缺货或积压，生成详尽的业务报表', '为采购计划、销售策略及成本核算提供精准数据支持，从而全面提升供应链效率，降低运营成本，优化资金流转'],
        icon: '/images/pages/products/feima/Frame 2147229636@2x.png',
        mainImage: '/images/pages/products/feima/Frame 2147229835@2x.png',
        direction: 'image-to-copywriting'
      },
    ]
  },
  coreBusiness: {
    title: '核心业务流程',
    mainImage: '/images/pages/products/feima/fm- (2).png'
  },
  advantage: {
    title: '产品优势',
    background: '/images/pages/products/feima/fm- (2).png',
    list: [
      {
        title: '数据一体  全程贯通',
        desc: '功能模块基于统一平台和数据标准，实现数据自动串联。这彻底打破了部门间的信息孤岛，确保业务数据在流转过程中准确、一致，形成完整的业务上闭环',
        icon: '/images/pages/products/feima/Frame 2147229757@2x.png',
      },
      {
        title: '运营协同  效率倍增',
        desc: '通过将客户管理、外勤轨迹、考勤、检核等流程深度整合，实现了跨部门的高效协同。极大减少了重复录入和沟通成本，全面提升团队执行力与运营效率',
        icon: '/images/pages/products/feima/Frame 2147229758@2x.png',
      },
      {
        title: '决策科学  洞察精准',
        desc: '报表分析功能能够基于全业务链的实时、真实数据，可视化的深度分析。管理者可以轻松洞察市场趋势、评估活动效果、优化产品结构、精准进行绩效考核，让每一步决策都有据可依',
        icon: '/images/pages/products/feima/Frame 2147229759@2x.png',
      },
      {
        title: '管理规范  风险可控',
        desc: '将进销存、检核、考勤等日常运营工作流程化、标准化,减少了对个人经验的依赖,降低了人为操作的差错和风险。严格的权限管理确保了数据安全,使企业管理更加规范、透明、可控',
        icon: '/images/pages/products/feima/Frame 2147229759@2x(1).png',
      }
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-feima-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .feima-product-advantage-item {
    width: 21.56rem;
    height: 26.94rem;
    border-radius: 0.57rem;
    background: linear-gradient(180deg, #d0e8ff 0%, #fff 100%);
    text-align: center;

    .feima-product-advantage-item-brief {
      width: 100%;
      height: 88.96px;
      border-radius: 0 0 20px 20px;
      background-size: cover;
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      line-height: 88.96px;
      text-align: center;
    }
  }

  .feima-business-number-cooperative-stores {
    position: absolute;
    top: 7.5rem;
    right: 0;
    display: flex;
    width: 264px;
    height: 85.12px;
    padding-top: 1.25rem;
    padding-left: 1.875rem;
    border-radius: 0;
    background-image: url("/images/pages/products/feima/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 32px;

      &::before {
        position: absolute;
        z-index: 0;
        top: 0.5rem;
        left: 0;
        width: 8px;
        height: 8px;
        box-sizing: content-box;
        border: 4px solid #e5ecfe;
        border-radius: 50%;
        background: rgb(var(--v-theme-primary));
        background-repeat: no-repeat;
        background-size: cover;
        content: "";
      }
    }
  }
}

.feima-product-advantage {
  background-image: url("/images/pages/products/feima/feima-product-advantage.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 18.75rem;
  gap: 16px;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
